export function refresh(contest , className , PcClass) {
	let deviceWidth = document.documentElement.clientWidth;
	// console.log ('当前窗口宽度',deviceWidth)
	if (deviceWidth > 1200) {
		contest.phoneClass = PcClass
		document.documentElement.style.fontSize = 1200 / 12 + "px";
	} else {
		deviceWidth < 750 ? contest.phoneClass = className : contest.phoneClass = PcClass
		document.documentElement.style.fontSize = deviceWidth / 7.5 + "px";
	}
}